// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
	resources: {}, // translations will be loaded dynamically from the API
	lng: "en", // default language
	fallbackLng: "en",
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
